import { PartialTranslation } from '../translations';

export const ka: PartialTranslation = {
  newChat: 'ახალი ჩატი',
  search: 'ძებნა',
  user: 'მომხმარებელი',
  settings: 'პარამეტრები',
  language: 'ენა',
  getHelp: 'დახმარების მიღება',
  viewAllPlans: 'ყველა გეგმის ნახვა',
  learnMore: 'მეტის გაგება',
  logOut: 'გასვლა',
  chooseLanguage: 'Выберите язык',
  chooseYourPreferredLanguage: 'Выберите предпочитаемый язык',
  searchLanguages: 'Поиск языков...',
  autoDetect: 'ავტომატური გამოვლენა',
  noLanguagesFound: 'Языки не найдены',
  askAnything: 'იკითხეთ ყველაფერი',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'პირადი',
  freePlan: 'უფასო გეგმა',
  current: 'Текущий',
  close: 'Закрыть',
  archive: 'Архивировать',
  delete: 'Удалить',
  confirmDelete: 'Вы уверены, что хотите удалить этот чат?',
  confirmArchive: 'Вы уверены, что хотите архивировать этот чат?',
  deleteCannotUndo: 'Это действие нельзя отменить.',
  archiveCanFind: 'Вы сможете найти его в списке архива после архивирования.',
  
  // 资源面板
  resources: 'რესურსები',
  addResource: 'რესურსის დამატება',
  deleteResource: 'Удалить ресурс',
  noMatchingResourcesFound: 'Подходящие ресурсы не найдены',
  noResourcesAvailable: 'Ресурсы недоступны',
  hideResources: 'Скрыть ресурсы',
  showResources: 'Показать ресурсы',
  
  // 聊天输入框
  typeMessage: 'შეიყვანეთ შეტყობინება...',
  thinkingOptions: 'Варианты размышления',
  deleteFile: 'Удалить файл',
  clearSelection: 'Очистить выбор',
  addAttachment: 'დანართის დამატება',
  sendMessage: 'შეტყობინების გაგზავნა',
  
  // 思考模式选项
  deepInsight: 'Глубокое понимание · Поверхностный анализ',
  deepInsightDesc: 'Быстрое понимание ключевых моментов',
  deepExploration: 'Глубокое исследование · Комплексный анализ',
  deepExplorationDesc: 'Многомерное углубленное исследование',
  deepDeconstruction: 'Глубокая деконструкция · Систематический аргумент',
  deepDeconstructionDesc: 'Послойный прогрессивный анализ',
  
  // 写作模式选项
  contractReview: 'Обзор контракта · Выявление рисков',
  contractReviewDesc: 'Анализ пунктов и проверка соответствия',
  textPolish: 'Полировка текста · Профессиональное выражение',
  textPolishDesc: 'Языковая оптимизация и структурная настройка',
  legalDocuments: 'Правовые документы · Стандартный проект',
  legalDocumentsDesc: 'Профессиональное написание правовых документов',

  // 认证和隐私翻译 (English fallback - needs translation)
  login: 'შესვლა',
  register: 'რეგისტრაცია',
  welcomeBack: 'კეთილი იყოს თქვენი მობრძანება LawHelper-ში',
  loginSubtitle: 'თქვენი AI სამართლებრივი კვლევის ასისტენტი',
  continueWithGoogle: 'გაგრძელება Google-ით',
  continueWithMicrosoft: 'გაგრძელება Microsoft-ით',
  continueWithWeChat: 'გაგრძელება WeChat-ით',
  orContinueWith: 'ან გაგრძელება',
  emailTab: 'ელფოსტა',
  phoneTab: 'ტელეფონი',
  emailPlaceholder: 'შეიყვანეთ თქვენი ელფოსტა',
  phonePlaceholder: 'შეიყვანეთ ტელეფონის ნომერი',
  codePlaceholder: 'შეიყვანეთ 6-ნიშნა კოდი',
  sending: 'იგზავნება...',
  verifying: 'მოწმდება...',
  verify: 'დადასტურება',
  sendMagicLink: 'გააგზავნეთ ჯადოს ბმული',
  getVerificationCode: 'კოდის მიღება',
  resendCode: 'კოდის ხელახლა გაგზავნა',
  resendIn: 'ხელახლა გაგზავნა',
  magicLinkSent: 'ჯადოს ბმული გაგზავნილია თქვენს ელფოსტაზე',
  magicLinkHint: 'ჩვენ გაგიგზავნით უსაფრთხო ბმულს თქვენს ელფოსტაზე',
  otpSent: 'დადასტურების კოდი გაგზავნილია',
  agreeToTerms: 'გაგრძელებით თქვენ ეთანხმებით ჩვენს',
  privacyPolicy: 'კონფიდენციალურობის პოლიტიკა',
  termsOfService: 'მომსახურების პირობები',
  and: 'და',
  privacyTitle: 'თქვენი კონფიდენციალურობა მნიშვნელოვანია',
  privacyIntro: 'ჩვენ ვიყენებთ ქუქი-ფაილებს და მსგავს ტექნოლოგიებს საუკეთესო გამოცდილების უზრუნველსაყოფად.',
  essentialCookies: 'აუცილებელი ქუქი-ფაილები',
  essentialDesc: 'საჭიროა ვებსაიტის მუშაობისთვის',
  analyticsCookies: 'ანალიტიკური ქუქი-ფაილები',
  analyticsDesc: 'გვეხმარება სერვისის გაუმჯობესებაში',
  marketingCookies: 'მარკეტინგული ქუქი-ფაილები',
  marketingDesc: 'გამოიყენება პერსონალიზებული შინაარსისთვის',
  acceptAll: 'ყველას მიღება',
  essentialOnly: 'მხოლოდ აუცილებელი',
  customize: 'მორგება',
  savePreferences: 'პარამეტრების შენახვა',
  back: 'უკან',
  readPrivacyPolicy: 'წაიკითხეთ ჩვენი კონფიდენციალურობის პოლიტიკა',
  cookiePolicy: 'ქუქი-ფაილების პოლიტიკა',
  gdprCompliance: 'GDPR',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'AI მიმოხილვა',
  aiDraft: 'AI პროექტი',
  smartAssistant: 'შაბლონი',

  // 知识库搜索
  enableKnowledgeSearch: 'ძიების ჩართვა',
  knowledgeSearchDesc: 'AI ეძებს თქვენს დოკუმენტებში',
  clickToDisable: 'გამორთვა',
  clickToEnable: 'ჩართვა',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'რესურსების პანელის დახურვა',
  uploading: 'Uploading %{fileName}...',
  processing: 'Processing %{fileName}...',
  uploadSuccess: '✓ %{fileName} uploaded successfully',
  uploadError: '✗ Upload failed: %{error}',
  quickAnswer: 'სწრაფი პასუხი',
  quickAnswerDesc: 'Fast response for simple questions',
  cancelRequest: 'გაუქმება',
  library: 'ბიბლიოთეკა',
  filterAll: 'ყველა',
  filterChat: 'Chats',
  filterReview: 'Review',
  filterDraft: 'Draft',
  filterTemplate: 'Template',
  filterForm: 'Form',
  thinking: 'ფიქრობს...',
  thinkingProcess: 'Thinking Process',
  analyzingLegalLogic: 'Analyzing legal logic...',
  lawhelperThinking: 'Lawhelper is thinking...',
  serviceError: 'სერვისის შეცდომა',
  uploaded: 'ატვირთულია',
  settingsGeneral: 'ზოგადი',
  settingsNotifications: 'შეტყობინებები',
  settingsAppearance: 'გარეგნობა',
  settingsProfile: 'პროფილი',
  settingsResponseNotifications: 'Response Notifications',
  settingsResponseNotificationsDesc: 'Get notified when AI finishes a response',
  settingsColorMode: 'Color Mode',
  settingsLight: 'ნათელი',
  settingsDark: 'მუქი',
  settingsSystem: 'სისტემა',
  about: 'შესახებ',
  reviewTitle: 'დოკუმენტის მიმოხილვა',
  exitReview: 'Exit Review',
  uploadPrompt: 'Upload PDF to start review',
  uploadButton: 'Select File',
  startChatConfig: 'Type "Review this document" to start',
  reviewPlaceholder: 'Type a message or "Review this document"...',
  analyzing: 'მიმოხილვა...',
  reviewComplete: 'Review Complete',
  issuesFound: 'Found %{count} issues',
  draftTitle: 'იურიდიული დოკუმენტის მომზადება',
  draftPlaceholder: 'Edit here or ask AI to generate...',
  analyzingTemplate: 'Analyzing template file %{name}...',
  templateAnalyzed: '✅ Template %{name} analyzed! Tell me how you want to modify or fill this template.',
  templateAnalysisPrompt: 'Analyze key clauses of this template',
  parsingFailed: '⚠️ Failed to parse file, but you can still describe your needs.',
  generating: 'იქმნება...',
  generatedSuccess: '✅ დოკუმენტი შეიქმნა!',
  drafterWelcome: 'Welcome to AI Document Assistant',
  drafterYouCan: 'You can:',
  drafterUploadTemplate: 'Upload a template for AI to analyze',
  drafterDescribeNeeds: 'Describe your document requirements',
  drafterLetAiHelp: 'Let AI help you draft contracts, agreements, etc.',
  drafterExamples: 'Examples:',
  drafterExampleRental: '"Help me draft a rental agreement"',
  drafterExampleLabor: '"Fill in the labor contract based on template"',
  drafterInputPlaceholder: 'Describe your document needs...',
  drafterThinking: 'Thinking...',
  drafterHistoryTitle: 'ისტორია',
  drafterNoHistory: 'ისტორია არ არის',
  drafterNewChat: 'ახალი ჩატი',
  drafterHistory: 'History',
  drafterRemoveAttachment: 'Remove attachment',
  drafterLineHeight: 'Line Height',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Export as Word (.docx)',
  drafterExportPdf: 'Export as PDF',
  drafterSave: 'დოკუმენტის შენახვა',
  drafterDownload: 'Download Document',
  drafterUndo: 'Undo',
  drafterRedo: 'Redo',
  drafterBold: 'Bold',
  drafterItalic: 'Italic',
  drafterStrike: 'Strikethrough',
  drafterUnderline: 'Underline',
  drafterHighlight: 'Highlight',
  drafterLink: 'Insert Link',
  drafterAlignLeft: 'Align Left',
  drafterAlignCenter: 'Align Center',
  drafterAlignRight: 'Align Right',
  drafterAlignJustify: 'Justify',
  drafterList: 'List',
  drafterBulletList: 'Bullet List',
  drafterOrderedList: 'Ordered List',
  drafterTaskList: 'Task List',
  drafterOpenResource: 'Open Resources Panel',
  drafterStopGeneration: 'Stop generation',
  drafterAgentMode: 'Agent mode enabled | Click to switch to normal chat',
  drafterAgentModeOn: 'Agent mode enabled | Click to switch to normal chat',
  drafterAgentModeOff: 'Normal chat mode | Click to switch to Agent mode',
  drafterUploadAttachment: 'Upload attachment',
  drafterExit: 'გასვლა',
  drafterConfirm: 'დადასტურება',
  drafterOpenLink: 'Open link',
  drafterDeleteLink: 'Delete link',
  drafterQuote: 'Quote',
  workflowTitle: 'AI Workflow',
  workflowRunning: 'Running...',
  workflowReady: 'მზადაა',
  workflowCompleted: 'დასრულდა',
  workflowStartFailed: 'Workflow start failed',
  workflowExecutionFailed: 'Workflow execution failed',
  workflowInterrupted: 'Workflow interrupted',
  workflowProcessing: 'Processing...',
  workflowStepsCompleted: 'steps completed',
  workflowStepsTotal: 'Workflow completed (%{count} steps)',
  acceptChanges: 'Accept Changes',
  rejectChanges: 'Reject Changes',
  changesAccepted: 'Changes accepted',
  changesRejected: 'Changes rejected',
  stopWorkflow: 'შეჩერება',
  restartWorkflow: 'Restart',
  startDrafting: 'მომზადების დაწყება',
  interrupt: 'Stop',
  documentSubject: 'Document Subject *',
  documentType: 'Document Type',
  jurisdiction: 'Jurisdiction',
  specialRequirements: 'Special Requirements (optional)',
  clickStartDrafting: 'Click "Start Drafting" to begin workflow',
  docTypeContract: 'ხელშეკრულება',
  docTypeAgreement: 'Agreement',
  docTypeNotice: 'Notice',
  docTypeLetter: 'წერილი',
  docTypePetition: 'Petition',
  docTypeWill: 'Will',
  docTypePowerOfAttorney: 'Power of Attorney',
  countryChina: 'China',
  countryUSA: 'United States',
  countryGermany: 'Germany',
  countryJapan: 'Japan',
  countryFrance: 'France',
  countryUK: 'United Kingdom',
  citationVerified: 'Verified',
  citationUnverified: 'Unverified',
  imageLoadFailed: 'Image failed to load',
  smartDocTitle: 'ჩკვიანი დოკუმენტის ასისტენტი',
  smartDocChatTitle: 'AI Document Assistant',
  smartDocDropPrompt: 'Drop PDF file here',
  smartDocSelectFile: 'Select File',
  smartDocOr: 'or',
  smartDocWelcomeTitle: 'Welcome to AI Document Assistant',
  smartDocWelcomeYouCan: 'You can:',
  smartDocUploadForAI: 'Upload a template for AI to analyze',
  smartDocDescribeDoc: 'Describe your document requirements',
  smartDocLetAIDraft: 'Let AI help you draft contracts, agreements, etc.',
  smartDocExamples: 'Examples:',
  smartDocExampleRental: '"Help me draft a rental agreement"',
  smartDocExampleLabor: '"Fill in the labor contract based on template"',
  smartDocInputPlaceholder: 'Describe your document needs...',
  smartDocRemoveAttachment: 'Remove attachment',
  smartDocOpenResources: 'Open Resources Panel',
  smartDocExit: 'Exit',
  reviewStartFailed: 'Review workflow start failed',
  reviewFailed: 'Review failed',
  reviewFoundIssues: 'Review complete, found %{count} issues.',
  cannotReadStream: 'Cannot read response stream',
  parseEventFailed: 'Failed to parse workflow event',
  errorPrefix: 'შეცდომა',
  unknownError: 'უცნობი შეცდომა',
  file: 'ფაილი',
  loading: 'იტვირთება...',
  localFolders: 'Local Folders',
  selectLocalFolder: 'Select Local Folder',
  reselectFolder: 'Change Folder',
  addToContext: 'Add to Chat',
  saveFile: 'Save',
  renameFile: 'Rename',
  fileSaved: 'File saved successfully',
  fileRenamed: 'File renamed to %{name}',
  browserNotSupported: 'Your browser does not support local folder access',
  noFolderSelected: 'Select a local folder to browse files',
  scanningFolder: 'Scanning folder...',
  selectFileToPreview: 'Select a file to preview',
  aiAnalyze: 'AI ანალიზი',
};
